import * as rest from './RestUtil';
import * as storage from '../util/StorageUtil';
import { getFunctionBaseUrl } from './RestUrls';

export const getPrivacyStatement = async (force: boolean = false) => {
  let terms = storage.getPrivacyStatement();
  if (!terms || force) {
    const url = `${getFunctionBaseUrl()}/api/getTerms`;
    const response = await rest.get(url);
    if(response && response.result) {
      storage.setPrivacyStatement(response.result);
      terms = response.result;
    } else {
      return response;
    }
  }
  return terms;
}